import { ProductCategory } from "@/products/entities/product-category"

export default class ProductDirectoryFilter {
  public onlyFolders: boolean = false
  public includeHidden: boolean = false
  public categories: ProductCategory[] = []
  public prunedTree: boolean = false
}
